import { render, staticRenderFns } from "./SaveReportModal.vue?vue&type=template&id=7ac72e23&scoped=true"
import script from "./SaveReportModal.vue?vue&type=script&lang=js"
export * from "./SaveReportModal.vue?vue&type=script&lang=js"
import style0 from "./SaveReportModal.vue?vue&type=style&index=0&id=7ac72e23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac72e23",
  null
  
)

export default component.exports